import React from 'react';
import LegalDocumentEditor from '../legal-document/LegalDocumentEditor';
import agreementApi from '../../services/agreementApi';

const DEFAULT_DOCUMENT = {
  title: 'KaamDhanda Partner Agreement',
  company: 'Nirvighna Services Private Limited',
  sections: [],
};

const AgreementEditor = () => (
  <LegalDocumentEditor
    permissionName="Partner Agreement"
    pageTitle="Partner Agreement Editor"
    pageDescription="Edit the partner agreement JSON document served by the public API."
    saveSuccessMessage="Partner Agreement saved successfully!"
    defaultDocument={DEFAULT_DOCUMENT}
    loadDocument={agreementApi.getAgreement}
    saveDocument={agreementApi.saveAgreement}
  />
);

export default AgreementEditor;
